<template>
  <div class="page flex-col">
    <img class="image_1" referrerpolicy="no-referrer"
      src="./assets/img/SketchPngfde1f62598caf7870214f6ea76dcb531550a76b33dbf4c02826ef5643ef124ae.png" />
    <div class="group_1 flex-row">

      <transition name="fade-move">
        <div class="cebianlan_guanbi flex-row" v-show="!cebianlanOpen">
          <img class="thumbnail_4" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
            @click="toggleSidebar" />
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="group_4 flex-col" v-show="cebianlanOpen">
          <div class="image-wrapper_2 flex-col" @click="gotoshouye1()">
            <img class="thumbnail_2" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng2f8376ef072d8731ef0759ac314175f81349de65e0879cbabee91899d239e979.png" />
          </div>
          <div class="box_1 flex-col"></div>
          <div class="box_2 flex-col" @mouseenter="showTooltip_gerenzhongxin" @mouseleave="hideTooltip_gerenzongxin"
            @click="gotogerenzhongxin()">
            <div class="image-wrapper_3 flex-col">
              <img class="thumbnail_3" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng01135b14fea1a6ed0f1d7a6a8f017e9925d08bd6a28672465f01adabe77a5515.png" />
            </div>
          </div>
          <div class="image-wrapper_4 flex-col" @mouseenter="showTooltip" @mouseleave="hideTooltip"
            @click="gotomianshilishi()">
            <img class="label_1" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng8e6cd64a36098966424450b0dad4bd1cc789add12a6963e32d14afbe743b5648.png" />
          </div>
          <div class="box_3 flex-col"></div>
          <el-dropdown placement="right"
            style="background-color: transparent;width:4.5vw;height:7.5vh;position:absolute;top:67.5vh;">
            <el-button style="background-color: transparent;border:none;width:100%;height:100%;">
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><button @click="logout">登出</button></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <img class="label_2" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng9b1b37eae056aad59317b4268670c0f9a45fa1b35ea31ef836a3198bcdd9f047.png" />
          <img class="thumbnail_4" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
            @click="toggleSidebar" />
        </div>
      </transition>
      <div class="cebianlan_group flex-col">
        <div v-show="isTooltipVisible_gerenzhongxin" class="cebianlan_text_wrapper1 flex-col">
          <span class="cebianlan_text">个人中心</span>
        </div>
        <div v-show="isTooltipVisible" class="cebianlan_text_wrapper2 flex-col">
          <span class="cebianlan_text">面试历史</span>
        </div>
      </div>
      <div class="group_5 flex-col">
        <div class="block_3 flex-row">
          <img class="group_2" referrerpolicy="no-referrer"
            src="./assets/img/SketchPnge3a1071ad23644845f66dc84e7cbfa6e0a0c201713eebcb2dac64a7c5b0e42f6.png" />
          <div class="section_1 flex-col justify-between">
              <span class="text_1">
                {{ name || '未获取到用户名' }}
              </span>
            <div class="text-wrapper_1 flex-col"><span class="text_3">绑定微信</span></div>
          </div>
          <!-- <div class="section_2 flex-col justify-between" @click="toggleEdit">
            <div class="image-wrapper_5 flex-col">
              <img
                class="thumbnail_5"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngb115bd869dce206d58f7f73b0c3772428d6104628cdc8d12720c4df288811b2b.png"
                
              />
            </div>
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng3453b2913adf09f7c0994fbfcb85e1f7d11664413b99d3ef583946cb15bed246.png"
            />
          </div> -->
        </div>
        <div class="image-text_1 flex-row justify-between" @mouseenter="showPhoneEdit" @mouseleave="hidePhoneEdit">
          <div class="text_2">
            手机号：
            <template v-if="isPhoneEditing">
              <input 
                ref="phoneInput"
                v-model="phoneNumber" 
                class="editable-input phone-input"
                @blur="savePhone"
                @keyup.enter="savePhone"
                pattern="[0-9]*"
              />
            </template>
            <template v-else>
              <span>{{ phoneNumber }}</span>
            </template>
          </div>
          <div v-show="showPhoneEditIcon && !isPhoneEditing" class="edit-icon" @click="startPhoneEdit">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng71e6add68f0cc04c45df7dd0820fafd3d15feca5570af337b3fd56da8d4405bf.png"
            />
          </div>
        </div>
        <span class="text_4">个人简介</span>
        <div class="block_2 flex-col">
          <div class="text-wrapper_2 flex-col">
            <textarea 
              v-model="personalIntro"
              class="editable-textarea"
              :class="{ 'textarea-expanded': showIntroControls }"
              placeholder="欢迎说说你的个人简介"
              @focus="showIntroButtons"
            ></textarea>
          </div>
          <div v-show="showIntroControls" class="group_6 flex-row justify-between">
            <div class="text-wrapper_3 flex-col" @click="cancelIntro">
              <span class="text_6">取消</span>
            </div>
            <div class="text-wrapper_4 flex-col" @click="saveIntro">
              <span class="text_7">确认</span>
            </div>
          </div>
        </div>
        <!-- 显示接口返回的数据 -->
        <p>接口返回的数据: {{ apiResponseData }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { test_center } from '../../api/user' // 导入接口

export default {
  data() {
    return {
      isTooltipVisible: false,
      isTooltipVisible_gerenzhongxin: false,
      tooltipTimeout: null,
      isEditing: false,
      phoneNumber: '15012128630',
      personalIntro: '',
      cebianlanOpen: true,
      showPhoneEditIcon: false,
      isPhoneEditing: false,
      showIntroControls: false,
      apiResponseData: null, // 用于存储接口返回的数据
    };
  },
  computed: {
    ...mapState('user', ['name', 'avatar'])
  },
  created() {
    console.log('Current name:', this.name)
    this.$store.dispatch('user/getInfo').then(() => {
      console.log('After getInfo, name:', this.name)
    }).catch(error => {
      console.error('Failed to get user info:', error)
    })
    this.fetchApiData(); // 调用接口获取数据
  },
  methods: {
    fetchApiData() {
      test_center().then(response => {
        this.apiResponseData = response.data; // 存储返回的数据
      }).catch(error => {
        console.error('获取数据失败:', error);
      });
    },
    showTooltip() {
      this.tooltipTimeout = setTimeout(() => {
        this.isTooltipVisible = true;
      }, 500);
    },
    hideTooltip() {
      clearTimeout(this.tooltipTimeout);
      this.isTooltipVisible = false;
    },
    gotomianshilishi() {
      this.$router.push('/lanhu_mianshilishi');
    },
    gotogerenzhongxin() {
      this.$router.push('/lanhu_gerenzhongxin');
    },
    showTooltip_gerenzhongxin() {
      this.tooltipTimeout = setTimeout(() => {
        this.isTooltipVisible_gerenzhongxin = true;
      }, 500);
    },
    hideTooltip_gerenzongxin() {
      clearTimeout(this.tooltipTimeout);
      this.isTooltipVisible_gerenzhongxin = false;
    },
    gotoshouye1() {
      this.$router.push('/lanhu_shouye1');
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
    },
    toggleSidebar() {
      this.cebianlanOpen = !this.cebianlanOpen
    },
    showPhoneEdit() {
      this.showPhoneEditIcon = true
    },
    hidePhoneEdit() {
      this.showPhoneEditIcon = false
    },
    startPhoneEdit() {
      this.isPhoneEditing = true
      this.$nextTick(() => {
        this.$refs.phoneInput.focus()
      })
    },
    savePhone() {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.phoneNumber)) {
        this.$message.error('请输入正确的手机号格式')
        this.phoneNumber = '15012128630'
      }
      this.isPhoneEditing = false
    },
    showIntroButtons() {
      this.showIntroControls = true
    },
    cancelIntro() {
      this.personalIntro = ''
      this.showIntroControls = false
    },
    saveIntro() {
      this.showIntroControls = false
    },
    logout() {
      this.$store.dispatch('user/logout')
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />

